import { v4 as uuidv4 } from 'uuid';

export const generateErrorId = (): string => {
  return `(Error ID: ${uuidv4()} please pass this ID to the support service)`;
};
